import { TooltipInline } from '@components/TooltipInline';
import { useFragment } from 'react-relay';
import { itemListEntryFragment } from './ItemListEntry.relay';
import type { ItemListEntryPropsType } from './types';

const ItemListEntry: React.FC<ItemListEntryPropsType> = (props: ItemListEntryPropsType) => {
  const component = useFragment(itemListEntryFragment, props.component);

  const { id, label, value, info, valueInfo, indent } = component;

  return (
    <div className="mt-[5px] flex items-start justify-between border-b border-page-bg py-[3px]" key={id}>
      <div className={`text-base text-accent max-[700px]:text-sm ${indent === '1' ? 'pl-[39px] max-[600px]:pl-0' : ''}`}>
        {label}
        <TooltipInline text={info} />
      </div>
      <div className="text-right text-[15px] text-black">
        {value}
        <TooltipInline text={valueInfo} />
      </div>
    </div>
  );
};

export { ItemListEntry };
